/**
 * Date / time formatting helpers used across the dashboard.
 *
 * Chunk 2B had formatDate() in names.js. This file adds formatDateTime()
 * for the scan log, plus formatRelative() for "2 minutes ago" style
 * timestamps on the scans list.
 *
 * British English everywhere: 22 April 2026, 14:30 (not 4/22/2026 2:30 PM).
 */

export function formatDateTime(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/**
 * Relative "x ago" format — "just now", "5 minutes ago", "2 hours ago",
 * "yesterday", "3 days ago", "2 weeks ago", then falls back to absolute
 * date for anything older than 4 weeks.
 */
export function formatRelative(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;

  const diffMs = Date.now() - d.getTime();
  const diffSec = Math.floor(diffMs / 1000);
  const diffMin = Math.floor(diffSec / 60);
  const diffHour = Math.floor(diffMin / 60);
  const diffDay = Math.floor(diffHour / 24);
  const diffWeek = Math.floor(diffDay / 7);

  if (diffSec < 30) return 'just now';
  if (diffMin < 1) return `${diffSec} seconds ago`;
  if (diffMin === 1) return '1 minute ago';
  if (diffMin < 60) return `${diffMin} minutes ago`;
  if (diffHour === 1) return '1 hour ago';
  if (diffHour < 24) return `${diffHour} hours ago`;
  if (diffDay === 1) return 'yesterday';
  if (diffDay < 7) return `${diffDay} days ago`;
  if (diffWeek === 1) return '1 week ago';
  if (diffWeek <= 4) return `${diffWeek} weeks ago`;

  // Older than 4 weeks — just show the absolute date
  return d.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}
